// Compatibility list props can still describe the WATI operator. While customer
// ownership is SRM-owned, the thread's subscribed canonical assignment is the
// only ownership source; an explicit null owner must not fall back to WATI.
export function canonicalOwnershipChat(chat, resource, policy, audience) {
  if (audience !== 'customer' || !policy?.known || !policy.enabled) return chat;
  const canonical = resource || chat?._canonical;
  const owner = canonical?.assignment?.assigned_to;
  return {
    ...chat,
    agent: owner?.display_name ?? null,
    agent_id: owner?.user_id ?? null,
    // Preserve the bot classification, never a provider human as SRM owner.
    provider_assignee: (canonical?.assignment?.provider_assignee ?? chat?.provider_assignee)?.kind === 'bot'
      ? (canonical?.assignment?.provider_assignee ?? chat.provider_assignee)
      : chat?.agent === 'Bot' ? { kind: 'bot', provider: 'wati' } : null,
    _canonical: canonical,
  };
}
